const SOL_MAIN_IMAGE = 'singlepage/startpage-solresor/solresor-parasol_wjhrfj'

// Facebook/X/LinkedIn og:image and schema.org image recommendation
const OG_IMAGE_WIDTH = 1200
const OG_IMAGE_HEIGHT = 630

enum MediaTypeEnum {
  IMAGE = 'image',
  VIDEO = 'video',
}

enum VideoProviderEnum {
  YOUTUBE = 'youtube',
}

enum ImageProviderEnum {
  GPTRAVEL = 'gptravel',
  HOTELBEDS = 'hotelbeds',
  CLOUDINARY = 'cloudinary',
  ROLFS_IMAGE = 'rolfs_image',
  RTG_HOTEL = 'rtg-hotel',
  EXPEDIA = 'expedia',
  GIATA = 'giata',
  OPENGDS = 'opengds',
  URL = 'url',
}

enum ImageFormatEnum {
  AVIF = 'avif',
  WEBP = 'webp',
}

/**
 * Ordered by preference, since a <picture> uses the first <source> whose type the browser
 * supports. AVIF has to come before the universally supported WEBP fallback.
 */
const PICTURE_IMAGE_FORMATS = [ImageFormatEnum.AVIF, ImageFormatEnum.WEBP]

const FALLBACK_IMAGE_FORMAT = ImageFormatEnum.WEBP

enum ImageSizeEnum {
  THUMBNAIL = 'thumbnail',
  LARGE = 'large',
  XLARGE = 'xlarge',
  OG = 'og',
  MAX = 'max',
  AUTO = 'auto',
  MAX_CONTAINER = 'max-container',
}

enum MediaResourceType {
  FOLDERS = 'folders',
  IMAGES = 'images',
}

const SWIPER_OPTIONS_PROPS_KEYS = [
  'verticalCenteredSlides',
  'pagination',
  'navigation',
  'autoplay',
  'autoHeight',
  'slidesPerView',
  'slidesPerGroup',
  'speed',
  'centered',
  'rewind',
  'loop',
  'initialSlide',
  'thumbs',
  'spaceBetween',
  'breakpoints',
  'slideToClickedSlide',
  'effect',
  'observer',
  'observeParents',
  'nested',
  'allowTouchMove',
  'coverflowEffect',
]

export {
  MediaTypeEnum,
  VideoProviderEnum,
  ImageProviderEnum,
  ImageFormatEnum,
  ImageSizeEnum,
  MediaResourceType,
  SWIPER_OPTIONS_PROPS_KEYS,
  PICTURE_IMAGE_FORMATS,
  FALLBACK_IMAGE_FORMAT,
  SOL_MAIN_IMAGE,
  OG_IMAGE_WIDTH,
  OG_IMAGE_HEIGHT,
}